<template>
  <ul class="my-action">
    <li v-for="persona in personalList" :key="persona.key">
      <p>{{persona.title}}</p>
      <ul class="action">
        <li v-for="(p,index) in persona.children" :key="index">
          <a :class="{active:$route.path.toLowerCase()===p.url.toLowerCase()}" :href="p.url" target="_self">{{p.name}}</a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
const personalList = [
  {
    title: "订单中心",
    key: 1,
    children: [
      {
        name: "我的订单",
        url: "/personalCenter/myOrder",
      },
      {
        name: "晒单评价",
        url: "/personalCenter/developPage",
      },
    ],
  },
  {
    title: "关注中心",
    key: 2,
    children: [
      {
        name: "收藏商品",
        url: "/personalCenter/followGoods",
      },
      {
        name: "关注品牌",
        // url: '/personalCenter/followBrand',
        url: "/personalCenter/developPage",
      },
      {
        name: "我的足迹",
        url: "/personalCenter/developPage",
      },
    ],
  },
  // {
  //   title: "资产中心",
  //   key: 3,
  //   children: [
  //     {
  //       name: "优惠卷",
  //       url: '/personalCenter/developPage',
  //     },
  //   ],
  // },
  {
    title: "客户服务",
    key: 4,
    children: [
      {
        name: "返修退换货",
        url: "/personalCenter/developPage",
      },
      {
        name: "退款管理",
        url: "/personalCenter/developPage",
      },
      {
        name: "交易纠纷",
        url: "/personalCenter/developPage",
      },
    ],
  },
  {
    title: "账户设置",
    key: 5,
    children: [
      {
        name: "个人信息",
        url: "/personalCenter/developPage",
      },
      {
        name: "账户绑定",
        url: "/personalCenter/userBind",
      },
      {
        name: "收货地址",
        url: "/personalCenter/shipAddress",
      },
    ],
  },
];
export default {
  data() {
    return {
      personalList,
    };
  },
  mounted() {
    this.personalList[0].children[0].url =
      this.$store.getters.orderPath || "/personalCenter/myOrder";
  },
};
</script>

<style lang="less" scoped>
.my-action {
  margin-right: 18px;
  // width: 142px;
  height: 563px;

  border: 1px solid rgba(244, 244, 244, 1);
  padding-top: 14px;
  box-sizing: border-box;
  li {
    padding: 0 30px;
    width: 80px;
    margin: 0 auto;
    margin-bottom: 20px;
    p {
      font-size: 18px;
      color: #000;
      margin-bottom: 8px;
    }
    .action {
      li {
        font-size: 14px;
        padding: 0;
        margin-bottom: 8px;
        a {
          color: #000000;
        }
        .active {
          color: @themeColor;
        }
      }
    }
  }
}
</style>